import { render, staticRenderFns } from "./PriceRules.vue?vue&type=template&id=496b7f44"
import script from "./PriceRules.vue?vue&type=script&lang=ts"
export * from "./PriceRules.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('496b7f44')) {
      api.createRecord('496b7f44', component.options)
    } else {
      api.reload('496b7f44', component.options)
    }
    module.hot.accept("./PriceRules.vue?vue&type=template&id=496b7f44", function () {
      api.rerender('496b7f44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/sale/PriceRules.vue"
export default component.exports